export const JACAR_ADMIN_API_URL = "https://jacar.co.kr/";
export const JACAR_BUSINESS_BASE_URL = "https://jacar.co.kr/business/";
export const LOTTE_CUSTOMER_COMPANY_NAME = "롯데 렌터";
